import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConstantsProviders } from '../../../core/providers/constants/constants';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { API_BASE_URL } from '../../../core/providers/constants/api.constants';
import {
  OpenSalesByDepartment,
  Transaction,
  TransactionLine,
} from '../types/transaction';
import { ApiRouteTransactionDto } from '../dto/purchase-order.dto';
import { ApiTransactionDto } from '../dto/transaction.dto';
import {
  TransactionData,
  TransactionsRangeDto,
} from '../types/transaction-data';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteTransactionService extends IApiBackendRouteService {
  urlRoute = `${API_BASE_URL}/transaction`;

  constructor(
    protected readonly http: HttpClient,
    protected readonly constants: ConstantsProviders
  ) {
    super();
  }

  getOne(id: number): Observable<Transaction> {
    return this.http.get<Transaction>(`${this.urlRoute}/${id}`);
  }

  insert(
    body: ApiRouteTransactionDto['insert']['body']
  ): Observable<Transaction> {
    return this.http.post<Transaction>(this.urlRoute, body);
  }

  dataLastUpdated(
    date: Date,
    type?: 'Purchase Order' | 'Sales Order'
  ): Observable<Transaction[]> {
    const strDate = date ? date.toISOString().split('T')[0] : null;
    let params = new HttpParams();
    if (type) {
      params = params.set('type', type);
    }
    return this.http.get<Transaction[]>(
      `${this.urlRoute}/last-updated/${strDate}`,
      { params }
    );
  }

  getSeveral(
    attributes: ApiTransactionDto['getSeveral']['queryParams']
  ): Observable<Transaction[]> {
    let params = new HttpParams();
    if (attributes.transactionType) {
      params = params.set('transactionType', attributes.transactionType);
    }
    attributes.specificIds.forEach((id) => {
      params = params.append('ids[]', id.toString());
    });
    return this.http.get<Transaction[]>(`${this.urlRoute}/several`, {
      params,
    });
  }

  updateSeveralLineRanks(
    body: ApiTransactionDto['updateLineRanks']['body']
  ): Observable<any> {
    return this.http.patch(`${this.urlRoute}/line/update-ranks`, body);
  }

  getLine(salesOrderLineId: number): Observable<TransactionLine> {
    return this.http.get<TransactionLine>(
      `${this.urlRoute}/line/${salesOrderLineId}`
    );
  }
  getTransactionData(wo: string): Observable<TransactionData> {
    return this.http.get<TransactionData>(this.urlRoute + '/data/' + wo);
  }
  updateTransactionRangeApi(
    transactionsRangeDto: TransactionsRangeDto
  ): Observable<Transaction[]> {
    return this.http.post<Transaction[]>(
      this.urlRoute + '/update-transaction-range',
      transactionsRangeDto
    );
  }
  insertByCache(
    body: ApiRouteTransactionDto['insert']['body']
  ): Observable<Transaction[]> {
    return this.http.post<Transaction[]>(this.urlRoute + '/cache', body);
  }

  getSalesByDepartment(department: string): Observable<OpenSalesByDepartment[]> {
    return this.http.get<OpenSalesByDepartment[]>(`${this.urlRoute}/sales-order?department=${department}`);
  }
}
